import {
  REQUEST_TOP_SEARCH_REASONS,
  RECEIVE_TOP_SEARCH_REASONS,
  RECEIVE_TOP_SEARCH_REASONS_ERROR,
} from './SearchBar-Actions';

const initialState = {
  isTopSearchReasonsLoading: false,
  isTopSearchReasonsAPICalled: false, // this flag is used to call top-search-reasons API only once
  TopSearchReasonsResponse: [],
  TopSearchReasonsError: false,
  customtopContactReasons: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TOP_SEARCH_REASONS: {
      return { ...initialState, isTopSearchReasonsLoading: true, isTopSearchReasonsAPICalled: true };
    }

    case RECEIVE_TOP_SEARCH_REASONS: {
      return {
        ...initialState,
        TopSearchReasonsResponse: action.payload,
        isTopSearchReasonsLoading: false,
        isTopSearchReasonsAPICalled: true,
        customtopContactReasons: action.customtopContactReasons,
      };
    }

    case RECEIVE_TOP_SEARCH_REASONS_ERROR: {
      return {
        ...initialState,
        TopSearchReasonsResponse: [],
        TopSearchReasonsError: true,
        isTopSearchReasonsLoading: false,
        isTopSearchReasonsAPICalled: true,
      };
    }
    default:
      return state;
  }
};

export default Reducer;
